import { render, staticRenderFns } from "./radio-button.vue?vue&type=template&id=18a77a32&"
import script from "./radio-button.vue?vue&type=script&lang=js&"
export * from "./radio-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18a77a32')) {
      api.createRecord('18a77a32', component.options)
    } else {
      api.reload('18a77a32', component.options)
    }
    module.hot.accept("./radio-button.vue?vue&type=template&id=18a77a32&", function () {
      api.rerender('18a77a32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/radio/src/radio-button.vue"
export default component.exports